export const listPaymentIntents = `
   query listPaymentIntents($filter: PaymentIntentsFilterInput, $limit: Int, $nextToken: String) {
       listPaymentIntents(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {
              id
              amount
              currency
              customerId
              description
              paymentMethod
              clientSecret
              status
              created
           }
           nextToken
       }
   }
`;

export const getPaymentIntent = `
   query getPaymentIntent($id:ID!) {
       getPaymentIntent(id:$id) {
              id
              amount
              currency
              customerId
              description
              paymentMethod
              clientSecret
              status
              created
       } 
}`;
